// extracted by mini-css-extract-plugin
module.exports = {"link":"navlink-module--link--2sSYg"};